import toArray from 'shadow-fns/src/toArray'
import reduce from './reduce'
import isObject from './isObject'

const select = (obj, cb) => {
  if (isObject(obj)) {
    return reduce(obj, (prev, key, val) => {
      if (cb(key, val) == true)
        prev[key] = val
    })
  }

  return toArray(obj)
    .filter((val, idx) => cb(val, idx) == true)
}

export default select
